







































































import Vue from 'vue';
import Component from 'vue-class-component';
import Axios from 'axios';
import ProjectService from '@/services/project.service';
import { Project } from '../../types';
import { Getter } from 'vuex-class';
import DropDown from '@/components/DropDown.vue';
import Dialog from '@/components/Dialog.vue';
import AppService from '@/services/apps.service';

@Component({
  components: {
    DropDown,
    Dialog,
  },
})
export default class InstallApplication extends Vue {
  @Getter private hasPermission!: any;
  @Getter private activeOrganisationId!: any;

  private showAvailableApps = true;
  private showInstallConfirmation = false;
  private requestedApp: any | null = null;
  private selectedVersion: string | null = null;
  private projects: any[] = [];
  private availableApplications: any[] = [];
  private selectedProject: any | null = null;

  private async mounted() {
    this.availableApplications = await AppService.getApplications();

    this.showAvailableApps = true;
  }

  private async requestAppInstall(name: string) {
    this.requestedApp = this.availableApplications.find((a: any) => a.name === name);

    this.selectedVersion = this.requestedApp.versions[0].version;
    const { projects } = await ProjectService.getProjects();
    this.projects = projects.map((p: Project) => ({ id: p.id, name: p.name }));
    this.showAvailableApps = false;
    this.showInstallConfirmation = true;
  }

  private selectProject(project: { value: number}) {
    this.selectedProject = project.value;
  }

  private close() {
    this.$emit('close');
  }

  private async installApp() {
    await AppService.installApplication(this.requestedApp.id, this.selectedVersion!, this.selectedProject);
    this.close();
  }
}
